import { Link } from "react-router-dom";

export const Footer = () => (
  <footer className="no-print border-t border-white/10 bg-black" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 sm:px-10 py-8 flex flex-col sm:flex-row items-center justify-between gap-4">
      <span className="text-xs text-white/40">
        © {new Date().getFullYear()} feNANCE Controlling Systems · Florian Ebert
      </span>
      <div className="flex items-center gap-5 text-xs">
        <a href="https://fenance.de" target="_blank" rel="noopener noreferrer" className="text-white/50 hover:text-brand-orange transition-colors">fenance.de</a>
        <Link to="/impressum" data-testid="footer-impressum" className="text-white/50 hover:text-brand-orange transition-colors">Impressum</Link>
        <Link to="/datenschutz" data-testid="footer-datenschutz" className="text-white/50 hover:text-brand-orange transition-colors">Datenschutz</Link>
      </div>
    </div>
  </footer>
);

export default Footer;
